import { useEffect } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import {
  CLUSTER_VALUES,
  ORIGIN_VALUES,
  COMMERCIAL_VALUES,
  ORDER_PAYMENT_VALUES,
  ORDER_SALES_STATUS_VALUES,
  formSchema,
  BotflowFormValue,
  ORDER_STATUS_VALUES,
} from '.';

export function useFinishChatForm() {
  const form = useForm({
    resolver: yupResolver(formSchema),
    defaultValues: {
      // criado campo para alterações futuras do tipo do cluster
      cluster: CLUSTER_VALUES['inactive'],
      origin: ORIGIN_VALUES['commercial'],
      support: '',
      financial: '',
      other: '',
      commercial: {
        type: COMMERCIAL_VALUES['sale_completed'],
        order: {
          name: '',
          value: '',
          payment: ORDER_PAYMENT_VALUES['credit'],
          status: ORDER_STATUS_VALUES['paid'],
          sales_status: ORDER_SALES_STATUS_VALUES['one-time-sale'],
        },
      },
      // campo para alterações futuras do tipo do botflow
      botflow: null as BotflowFormValue | null,
    },
    mode: 'onChange',
  });

  // Altera o valor do botflow quando o cluster é ativo
  const { watch, setValue } = form;
  const cluster = watch('cluster');
  const isClusterActive = cluster === CLUSTER_VALUES.active;
  const commercialType = watch('commercial.type');

  useEffect(() => {
    if (isClusterActive && commercialType === COMMERCIAL_VALUES.other) {
      setValue('botflow', {
        flow_id: '' as string,
      });
    }
  }, [isClusterActive, commercialType, setValue]);

  return {
    ...form,
  };
}
